import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "components/Common/Breadcrumb2";
import { fetchAssignmentsRequest } from "store/assignment/actions";
import AssignmentTable from "./assignmentTable";

const AssignmentList = () => {
  const dispatch = useDispatch();
  const { assignments, loading } = useSelector((state) => state.Assignment);

  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState("");
  const [selectedCreator, setSelectedCreator] = useState(null);
  const [selectedSortData, setSelectedSortData] = useState({
    value: "createdAt",
    direction: "desc",
  });
  const [selectedStatus, setSelectedStatus] = useState(null);

  // API call on every relevant change
  useEffect(() => {
    const params = {
      page: pageIndex,
      limit: pageSize,
    };

    if (searchString?.trim()) params.search = searchString.trim();
    if (selectedCreator?.value) params.createdBy = selectedCreator.value;
    if (selectedStatus?.value) params.status = selectedStatus.value;
    if (selectedSortData?.value && selectedSortData?.direction)
      params.sortBy = `${selectedSortData.value}:${selectedSortData.direction}`;

    console.log("Fetch Assignments Params:", params);
    dispatch(fetchAssignmentsRequest(params));
  }, [
    dispatch,
    pageIndex,
    pageSize,
    searchString,
    selectedCreator,
    selectedStatus,
    selectedSortData,
  ]);

  //  Reset to first page when filters/search change
  useEffect(() => {
    setPageIndex(1);
  }, [searchString, selectedCreator, selectedStatus]);

  const creatorOptions =
    assignments?.data
      ?.map((item) => item.createdBy)
      ?.filter(Boolean)
      ?.filter(
        (c, i, arr) =>
          arr.findIndex((a) => a?._id === c?._id) === i
      )
      ?.map((creator) => ({
        label: creator.name || "Unknown",
        value: creator._id,
      })) || [];

  return (
    <div className="page-content container-fluid">
      <Breadcrumb
        title="Assignments"
        breadcrumbItems={[
          { title: "Dashboard", link: "/dashboard" },
          { title: "Assignments", link: "#" },
        ]}
      />
      <AssignmentTable
        assignments={assignments?.data || []}
        loading={loading}
        totalrows={assignments?.total || 0}
        // 🔹 pass full control states
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        pageSize={pageSize}
        setPageSize={setPageSize}
        searchString={searchString}
        setSearchString={setSearchString}
        selectedCreator={selectedCreator}
        setSelectedCreator={setSelectedCreator}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        selectedSortData={selectedSortData}
        setSelectedSortData={setSelectedSortData}
        creatorOptions={creatorOptions}
      />
    </div>
  );
};

export default AssignmentList;
